export const PSYCHICS_PATH = "psychics";

export const PR_SITE_CONFIGURATION = {
	[PSYCHICS_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
};
